var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.636 21.252h-7.438a.342.342 0 01-.338-.345v-8.973a.683.683 0 00-.677-.69.683.683 0 00-.676.69v9.318c0 .763.606 1.381 1.353 1.381h7.776a.683.683 0 00.676-.69.683.683 0 00-.676-.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.488 11.283l-1.923-1.932a.591.591 0 00-.423-.18h-5.67c-.33 0-.598.274-.598.612v9.744c0 .338.268.611.599.611h7.592c.331 0 .6-.273.6-.611v-7.81a.618.618 0 00-.177-.434z"
  }))));
};

export default SvgDuplicate;